<template>
  <div class="bg-white">
    <CoverPage />
    <div class="">
      <div class="container md:px-12 px-6">
        <AboutUs />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555 md:mt-12 lg:mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import AboutUs from "./components/AboutUs.vue";
import CoverPage from "./components/CoverPage.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
export default {
  components: {
    CoverPage,
    AboutUs,
    DownloadApp,
    Footer,
  },
  metaInfo: {
    title: "Join us at Caregiver Saathi community-Empower yourself",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Joining our community is free! Connect with peer caregivers, share your story, get access to support & multiple benefits to ease your caregiving journey",
      },
    ],
  },
};
</script>
